import React from 'react';
import Button from '../../../components/ui/Button';

const FormNavigationControls = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSaveDraft,
  isNextDisabled,
  isSaving 
}) => {
  return (
    <div className="sticky bottom-0 bg-background border-t border-border p-4 lg:p-6 shadow-lg">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Button
            variant="outline"
            iconName="Save"
            iconPosition="left"
            onClick={onSaveDraft}
            loading={isSaving}
            className="order-3 sm:order-1"
          >
            Save Draft
          </Button>

          <div className="flex gap-3 sm:gap-4 flex-1 order-1 sm:order-2">
            {currentStep > 1 && (
              <Button
                variant="outline"
                iconName="ChevronLeft"
                iconPosition="left"
                onClick={onPrevious}
                className="flex-1 sm:flex-none"
              >
                Previous
              </Button>
            )}

            <Button
              variant="default"
              iconName={currentStep === totalSteps ? "Check" : "ChevronRight"}
              iconPosition="right"
              onClick={onNext}
              disabled={isNextDisabled}
              fullWidth={currentStep === 1}
              className="flex-1"
            >
              {currentStep === totalSteps ? 'Complete Registration' : 'Next Step'}
            </Button>
          </div>
        </div>

        <div className="mt-3 text-center">
          <p className="text-xs text-muted-foreground">
            Step {currentStep} of {totalSteps} • {
              currentStep === 2 
                ? 'Use Save buttons to save coach information' 
                : currentStep === 3
                ? 'Click Save button on each player card to persist their information'
                : 'Your progress is automatically saved'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormNavigationControls;